module.exports = __webpack_public_path__ + "static/media/elsa-jean-lesb.035fcf8d.jpg";